module.exports = "/assets/webpack/production/fonts/slick_ced611daf7709cc778da928fec876475.eot";